import { Fragment } from "react";
import * as utils from "common/utils";
import Watermark from "components/Watermark";
import { SummaryRow } from "components/PlanningReport";
import { useAnalysisSummary } from "containers/BudgetHome";

export default function FarmSoils({ farm, before, after }) {
    const { data: beforeInputs } = useAnalysisSummary(before?.details);
    const { data: afterInputs } = useAnalysisSummary(after?.details);

    if (!beforeInputs && !afterInputs) {
        return null;
    }

    const { soils: afterSoils } = afterInputs || {};
    const { soils: beforeSoils = [] } = beforeInputs || {};
    const isComparing = !!before && !!after;
    const allSoils = afterSoils.map((sd) => ({ order: sd.order, group: sd.group, isModified: sd.isModified, name: sd.name, category: `${sd.group}/${sd.order}  ${sd.name || ""}` }));
    const uniqueSoils = Array.from(new Map(allSoils.map((item) => [JSON.stringify([item.group, item.order, item.name, item.isModified]), item])).values());

    return (
        <div className="ReportSection">
            <h1>Farm soils</h1>
            <div className="Table Table-Compressed">
                <Watermark />
                <table>
                    <thead>
                        <tr>
                            <th data-width="25"></th>
                            <th></th>
                            {isComparing && (
                                <th className="numeric u-before" data-width="12.5">
                                    {utils.truncateText(before.displayName, 35)}
                                </th>
                            )}
                            <th className={`numeric ${isComparing ? "u-after" : ""}`} data-width="12.5">
                                {utils.truncateText(after.displayName, 35)}
                            </th>
                            {isComparing && (
                                <th className="numeric" data-width="16.7">
                                    Change
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {uniqueSoils
                            .sort((a, b) => (a.category > b.category ? 1 : -1))
                            .map((us, i) => {
                                const category = us.category;
                                const actualCatSoils = afterSoils.filter((sd) => sd.group === us.group && sd.order === us.order && sd.name === us.name && sd.isModified === us.isModified);
                                const baseCatSoils = beforeSoils.filter((sd) => sd.group === us.group && sd.order === us.order && sd.name === us.name && sd.isModified === us.isModified);

                                const actualSoilTotal = actualCatSoils.reduce((total, soil) => total + soil?.totalArea?.value, 0) || 0;
                                const baseSoilTotal = baseCatSoils.reduce((total, soil) => total + soil?.totalArea?.value, 0) || 0;

                                const baseSoilModified = baseCatSoils ? (us.isModified ? "Yes" : "No") : "-";
                                const actualSoilModified = actualCatSoils ? (us.isModified ? "Yes" : "No") : "-";

                                return (
                                    <Fragment key={i}>
                                        <SummaryRow beforeValue={baseSoilTotal} afterValue={actualSoilTotal} isComparing={isComparing} category={category} label="Area" />
                                        <SummaryRow beforeValue={baseSoilModified} afterValue={actualSoilModified} isComparing={isComparing} category=" " label="Properties modified" prefix={category} dispalyValuesAsText />
                                    </Fragment>
                                );
                            })}
                    </tbody>
                </table>
            </div>
            <div className="u-ml-sm">
                <sub style={{ lineHeight: "1rem" }}>1 - Olsen P is calculated using soil test results, proportioned by the area of the farm that this soil covers.</sub>
            </div>
        </div>
    );
}
